import axios from 'axios';
import router from '../router';
import loadingStore from '../loading';

// Relative URL so the dev-server proxy in vue.config.js forwards to the real API
// on whatever port this app is running.
const apiURL = 'https://mis.worxpace.gr/backend/api';

const apiClient = axios.create({
  baseURL: apiURL, // Replace with your API base URL
  headers: {
    'Content-Type': 'application/json',
  },
});

// Dev-only demo data (npm run serve:mock). The require is dropped from production builds.
if (process.env.NODE_ENV !== 'production' && process.env.VUE_APP_MOCK === '1') {
  apiClient.defaults.adapter = require('../mock/adapter').default;
  // Open /?mocklogin to see the login screen; otherwise start signed in.
  // ?mocktheme=dark|light presets the theme (handy for screenshots).
  const mockParams = new URLSearchParams(window.location.search);
  if (mockParams.get('mocktheme')) localStorage.setItem('theme', mockParams.get('mocktheme'));
  if (mockParams.has('mocklogin')) {
    localStorage.removeItem('api_token');
  } else {
    localStorage.setItem('api_token', 'mock');
    localStorage.setItem('current_user_id', '1');
  }
}

// Request interceptor to add the API token and show loading spinner
apiClient.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('api_token'); // Adjust as needed
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }

    // Only show loading if noLoading is NOT set to true
    if (!config.noLoading) {
      loadingStore.setLoading(true); // Show loading spinner
    }

    return config;
  },
  (error) => {
    loadingStore.setLoading(false); // Hide loading spinner
    return Promise.reject(error);
  }
);

// Response interceptor to handle 401 errors and hide loading spinner
apiClient.interceptors.response.use(
  (response) => {
    // Hide loading spinner if noLoading is not set to true
    if (!response.config.noLoading) {
      loadingStore.setLoading(false);
    }
    return response;
  },
  (error) => {
    loadingStore.setLoading(false);

    const currentRouteName = router.currentRoute.value.name;

    const publicRoutes = ['ResetPassword', 'NewEmployeeForm', 'Login']; 

    if (
      error.response &&
      error.response.data?.message?.includes('Unauthenticated') &&
      !publicRoutes.includes(currentRouteName)
    ) {
      sessionStorage.setItem('redirectAfterLogin', window.location.href);

      // Redirect to the login page
      router.push({ name: 'Login' }); 
    }

    return Promise.reject(error);
  }
);

export default apiClient;
